define("shared/components/shared/post/secondary/publishing-method-setup/auto-publish-setup/index", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/runloop", "@ember/service", "@glimmer/component", "ember-concurrency", "later/errors/credentials", "later/utils/object-promise-proxy"], function (_exports, _component, _templateFactory, _object, _runloop, _service, _component2, _emberConcurrency, _credentials, _objectPromiseProxy) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _displaySuccessAlert;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/runloop",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"later/errors/credentials",0,"later/utils/object-promise-proxy"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if @socialProfile.isInstagram}}
    {{#if @socialProfile.isProfessional}}
      {{! Enable Auto Publish - Instagram }}
      <Shared::Post::Secondary::PublishingMethodSetup::Layout
        @image="/assets/images/img--nonPublishedPosts--setUp__ig__auto__publishing.png"
        @title={{t "onboarding.side_wiz.general.set_up_auto_publishing.heading"}}
      >
        <:body>
          <Shared::Post::Secondary::PublishingMethodSetup::AutoPublishSetup::EnableInstagram />
        </:body>
        <:footer>
          <Shared::Ui::Button
            @additional="block"
            @isDisabled={{this.connectFacebook.isRunning}}
            @text={{t "onboarding.side_wiz.general.set_up_auto_publishing.btn_connect_facebook"}}
            @variant="primary"
            class="qa--setup_fbconnect_btn"
            {{on "click" (perform this.connectFacebook)}}
          />
          <Shared::Ui::Button
            @additional="block"
            @onClick={{@handleClose}}
            @text={{t "onboarding.side_wiz.general.cancel"}}
            @variant="outline"
            class="qa--setup_cancel_btn"
          />
        </:footer>
      </Shared::Post::Secondary::PublishingMethodSetup::Layout>
    {{else}}
      {{! Switch to Business - Instagram }}
      <Shared::Post::Secondary::PublishingMethodSetup::Layout
        @image="/assets/images/img--nonPublishedPosts--switching__ig__business__profile.png"
        @title={{t "onboarding.side_wiz.general.set_up_auto_publishing.heading2"}}
      >
        <:body>
          <Shared::Post::Secondary::PublishingMethodSetup::AutoPublishSetup::SwitchBusinessInstagram />
        </:body>
        <:footer>
          <Shared::Ui::Button
            @additional="block"
            @text={{t "onboarding.side_wiz.general.set_up_auto_publishing.btn_update"}}
            @variant="primary"
            {{on "click" (perform this.checkProfileType)}}
          />
          <Shared::Ui::Button
            @additional="block"
            @text={{t "onboarding.side_wiz.general.cancel"}}
            @variant="outline"
            {{on "click" @handleClose}}
          />
        </:footer>
      </Shared::Post::Secondary::PublishingMethodSetup::Layout>
    {{/if}}
  {{/if}}
  */
  {
    "id": "jebbn1Gg",
    "block": "[[[41,[30,1,[\"isInstagram\"]],[[[41,[30,1,[\"isProfessional\"]],[[[1,\"    \"],[8,[39,1],null,[[\"@image\",\"@title\"],[\"/assets/images/img--nonPublishedPosts--setUp__ig__auto__publishing.png\",[28,[37,2],[\"onboarding.side_wiz.general.set_up_auto_publishing.heading\"],null]]],[[\"body\",\"footer\"],[[[[1,\"\\n        \"],[8,[39,3],null,null,null],[1,\"\\n      \"]],[]],[[[1,\"\\n        \"],[8,[39,4],[[24,0,\"qa--setup_fbconnect_btn\"],[4,[38,5],[\"click\",[28,[37,6],[[30,0,[\"connectFacebook\"]]],null]],null]],[[\"@additional\",\"@isDisabled\",\"@text\",\"@variant\"],[\"block\",[30,0,[\"connectFacebook\",\"isRunning\"]],[28,[37,2],[\"onboarding.side_wiz.general.set_up_auto_publishing.btn_connect_facebook\"],null],\"primary\"]],null],[1,\"\\n        \"],[8,[39,4],[[24,0,\"qa--setup_cancel_btn\"]],[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[30,2],[28,[37,2],[\"onboarding.side_wiz.general.cancel\"],null],\"outline\"]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"    \"],[8,[39,1],null,[[\"@image\",\"@title\"],[\"/assets/images/img--nonPublishedPosts--switching__ig__business__profile.png\",[28,[37,2],[\"onboarding.side_wiz.general.set_up_auto_publishing.heading2\"],null]]],[[\"body\",\"footer\"],[[[[1,\"\\n        \"],[8,[39,7],null,null,null],[1,\"\\n      \"]],[]],[[[1,\"\\n        \"],[8,[39,4],[[4,[38,5],[\"click\",[28,[37,6],[[30,0,[\"checkProfileType\"]]],null]],null]],[[\"@additional\",\"@text\",\"@variant\"],[\"block\",[28,[37,2],[\"onboarding.side_wiz.general.set_up_auto_publishing.btn_update\"],null],\"primary\"]],null],[1,\"\\n        \"],[8,[39,4],[[4,[38,5],[\"click\",[30,2]],null]],[[\"@additional\",\"@text\",\"@variant\"],[\"block\",[28,[37,2],[\"onboarding.side_wiz.general.cancel\"],null],\"outline\"]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]]]],[]],null]],[\"@socialProfile\",\"@handleClose\"],false,[\"if\",\"shared/post/secondary/publishing-method-setup/layout\",\"t\",\"shared/post/secondary/publishing-method-setup/auto-publish-setup/enable-instagram\",\"shared/ui/button\",\"on\",\"perform\",\"shared/post/secondary/publishing-method-setup/auto-publish-setup/switch-business-instagram\"]]",
    "moduleName": "shared/components/shared/post/secondary/publishing-method-setup/auto-publish-setup/index.hbs",
    "isStrictMode": false
  });

  let AutoPublishComponent = (_class = (_displaySuccessAlert = /*#__PURE__*/new WeakSet(), class AutoPublishComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _displaySuccessAlert);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "errors", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _initializerDefineProperty(this, "onboarding", _descriptor4, this);

      _initializerDefineProperty(this, "segment", _descriptor5, this);
    }

    get socialProfile() {
      return this.args.socialProfile;
    }

    *checkProfileType() {
      const socialProfile = yield (0, _objectPromiseProxy.default)(this.socialProfile);
      this.segment.track('clicked-check-profile-type');
      yield socialProfile.get('refreshAndReload').perform();

      if (!socialProfile.isProfessional) {
        if (socialProfile.isInstagram) {
          this.alerts.alert(this.intl.t('alerts.posts.edit.instagram.creator_or_personal.message', {
            username: socialProfile.nickname
          }), {
            title: this.intl.t('alerts.posts.edit.instagram.creator_or_personal.title', {
              username: socialProfile.nickname
            })
          });
        }
      }
    }

    *connectFacebook() {
      const socialProfile = yield (0, _objectPromiseProxy.default)(this.socialProfile);
      this.segment.track('attempted-connecting-facebook');
      (0, _runloop.later)(() => {
        this.alerts.info(this.intl.t('alerts.onboarding.auto_publishing.message'), {
          title: this.intl.t('alerts.onboarding.auto_publishing.title'),
          preventDuplicates: true
        });
      }, 3000);

      try {
        yield this.onboarding.connectBusinessAccount.perform(socialProfile, 'onboarding');

        if (!socialProfile.canAutoPublish) {
          this.args.showCredentialsWizard();
        }

        if (this.args.shouldEnablePostAutoPublish) {
          (0, _object.set)(this.args.post, 'autoPublish', !this.args.post.autoPublish);
        }

        _classPrivateMethodGet(this, _displaySuccessAlert, _displaySuccessAlert2).call(this);

        this.args.handleClose();
      } catch (error) {
        if (error instanceof _credentials.CredentialsNotFoundError) {
          this.args.showCredentialsWizard();
        } else {
          this.errors.log('connect Facebook error', error);
        }
      }
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "onboarding", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "checkProfileType", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "checkProfileType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "connectFacebook", [_emberConcurrency.task], Object.getOwnPropertyDescriptor(_class.prototype, "connectFacebook"), _class.prototype)), _class);
  _exports.default = AutoPublishComponent;

  function _displaySuccessAlert2() {
    this.alerts.success(this.intl.t('onboarding.side_wiz.general.set_up_auto_publishing.instagram.success_alert.message', {
      username: this.socialProfile.nickname
    }), {
      title: this.intl.t('onboarding.side_wiz.general.set_up_auto_publishing.instagram.success_alert.title')
    });
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AutoPublishComponent);
});